import { clamp } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Counter } from '@swf/core/types/Notification';

interface Props {
  counter: keyof Counter;
}

const CounterBadge: React.FC<Props> = ({ counter }) => {
  const counters = useSelector(select.notification.getCounters);
  const value = counters[counter] || 0;
  const displayValue = clamp(value, 0, 99);

  return value ? <span>{displayValue}</span> : null;
};

export default CounterBadge;
